import React from 'react'
import PropTypes from 'prop-types'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import theme from '@components/theme'

export const Informer = ({ label, text, color }) => {
  const boxStyles = {
    borderLeftStyle: 'solid',
    borderLeftWidth: '8px',
    borderLeftColor: theme.pallete[color] || theme.pallete.secondary,
    p: '0 16px',
    m: '16px 0'
  }

  return (
    <Box sx={boxStyles}>
      <Typography variant="h4" sx={{ mb: '10px' }}>
        {label}
      </Typography>

      {text && (
        <Typography variant="body1" display="inline">
          {text}
        </Typography>
      )}
    </Box>
  )
}

Informer.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node
  ]).isRequired,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node
  ]),
  color: PropTypes.string
}

export default Informer
